//#region [IMPORT]

import React, { createContext, useEffect, useState } from "react";
import { on, removeListener, sendMessageData } from "api/prokey/prokey.websocket";

//#endregion

//#region [VALUES]

const AppContext = createContext()

//#endregion

//-----------------------------------------------------------------
function AppProvider( { children } ) {
  //-----------------------------------------------------------------
  //#region [VALUES]

  const [ user_details, setUserDetails ] = useState( { roles: [] } );

  //#endregion

  //#region [EFFECT]
  
  useEffect( () => {
    //-----------------------------------------------------------------
    function _handleUserDetails( data ) {
      //-----------------------------------------------------------------
      data.display_name =  `${data.FirstName} ${data.LastName} (${data.Username})`;
      data.initials = 
        data.FirstName.substring( 0, 1 )
      + data.LastName .substring( 0, 1 );

      setUserDetails( data );
    }

    on( 'USER_DETAILS', _handleUserDetails );
        
    sendMessageData( 'USER_DETAILS_REQUEST' );

    return () => {
      removeListener( 'USER_DETAILS', _handleUserDetails );
    }
  }, [] );

  //#endregion

  return (
    <AppContext.Provider value={ {user_details} }>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };